import LoadGoogleAPI from '@/store/calendar/google/load-google-api.js'
import googleConfig from '@/store/calendar/google/google-client-config.js'
import moment from '@/moment-gp'

// TODO: this.googleAPI.unload();
let googleAPI = new LoadGoogleAPI(googleConfig);

// -----------------------------------------------------------------------------
function updateSigninStatus({ commit }, isSignedIn) {
  console.log("updateSigninStatus:", isSignedIn);

  if (isSignedIn) {
    googleAPI.writeStorage('token', '123467890')
    commit("CALENDAR_AUTHORIZED", 1);
  } else {
    commit("CALENDAR_AUTHORIZED", 0);
  }
}

// -----------------------------------------------------------------------------
function google_calendar_onload({ commit }) {

  if ( googleAPI.readStorage('token') ) {
    console.log("calendar_onload: token exist");
  }

  let authdata = googleAPI.readStorage('authdate')
  if (authdata !== null) {
    commit("CALENDAR_AUTH_DATE", authdata);
  }

  googleAPI.loadGoogleAPI().then(() => {

    console.log("calendar_onload: loadGoogleAPI complete");
    console.log("calendar_onload: window.gapi =>", window.gapi);

    // Listen for sign-in state changes.
    let isSignedIn = window.gapi.auth2.getAuthInstance().isSignedIn;

    // console.log("isSignedIn", isSignedIn);
    isSignedIn.listen((state) => {
      updateSigninStatus({ commit }, state);
    });

    // Handle the initial sign-in state.
    updateSigninStatus({ commit }, isSignedIn.get());
  }).catch(() => {
    console.log("calendar_onload: login failed");
    commit("CALENDAR_AUTHORIZED", -1);
  })
}

// -----------------------------------------------------------------------------
function google_calendar_auth({ commit }) {
  console.log("google_calendar_auth");
  // commit("CALENDAR_AUTHORIZED", 1);
  // commit("CALENDAR_AUTHORIZED", -1);
  let auth = window.gapi.auth2.getAuthInstance();

  if ( auth ) {
    auth.signIn();

    console.log('google_calendar_auth: setting auth date (HACK)');
    let now = moment.currentTime();
    googleAPI.writeStorage('authdate', now.toISOString())
    commit("CALENDAR_AUTH_DATE", now.toISOString());
  }
}

// -----------------------------------------------------------------------------
function google_calendar_unauth({ commit }) {
  console.log("google_calendar_unauth");

  let auth = window.gapi.auth2.getAuthInstance();

  if ( auth ) {
    auth.signOut();
    googleAPI.unload(); // ?

    googleAPI.writeStorage('token', null);
    googleAPI.writeStorage('authdate', null);
    commit("CALENDAR_AUTHORIZED", 0);
    commit("CALENDAR_AUTH_DATE", null);
  }
}

// -----------------------------------------------------------------------------
// function google_calendar_connect({ commit }, buttonClick) {
//
//   // Set google api locally
//   let gapi = window.gapi;
//   console.log("loadGoogleAPI complete! window.gapi => ", gapi);
//
//   // Listen for sign-in state changes.
//   let isSignedIn = gapi.auth2.getAuthInstance().isSignedIn;
//   isSignedIn.listen(this.updateSigninStatus);
//
//   // Handle the initial sign-in state.
//   this.updateSigninStatus(isSignedIn.get());
// }

// -----------------------------------------------------------------------------
function google_create_event({ commit }, { summary, date, fromTime, toTime }) {
  const event_data = {
    'summary': summary,
    'description': '',
    'start': {
      'dateTime': date + 'T' + fromTime,
      'timeZone': 'Europe/Berlin'
    },
    'end': {
      'dateTime': date + 'T' + toTime,
      'timeZone': 'Europe/Berlin'
    }
  }
  console.log("create_event", event_data);

  window.gapi.client.calendar.events.insert({
    'calendarId': 'primary',
    'resource': event_data
  }).execute((event) => {
    console.log("event", event);
    commit('ADD_EVENT', event);
  });
}

// -----------------------------------------------------------------------------
function google_fetch_all_events({ commit }) {
  window.gapi.client.calendar.events
    .list({
      calendarId: "primary",
      timeMin: moment.currentTime().toISOString(),
      showDeleted: false,
      singleEvents: true,
      maxResults: 8,
      orderBy: "startTime"
    })
    .then((response) => {
      commit('RESET_EVENTS');
      let events = response.result.items;
      events.forEach(event => {
        commit('ADD_EVENT', event);
      });
    });
}

export default {
  google_calendar_onload,
  google_calendar_auth,
  google_calendar_unauth,
  // google_calendar_connect,
  google_create_event,
  google_fetch_all_events
}
